/* ============================================================
   UNDER THE CROSS — 2026
   Η λογική του νέου σχεδίου, δεμένη με το καλάθι του Shopify.
   Χωρίς εξαρτήσεις.
   ============================================================ */
(function () {
  'use strict';

  var U = window.UTC || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- χρήματα ---------- */
  function money(cents) {
    var v = (cents / 100).toFixed(2).replace('.', ',');
    return v + ' €';
  }

  /* ---------- toast ---------- */
  var toastEl = $('#toast'), toastTimer;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('on'); }, 2600);
  }

  /* ---------- συρόμενα πάνελ ---------- */
  var scrim = $('#scrim');
  function openPanel(id) {
    $$('.panel').forEach(function (p) { p.classList.remove('on'); p.setAttribute('aria-hidden', 'true'); });
    var p = document.getElementById(id);
    if (!p) return;
    p.classList.add('on');
    p.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('on');
    document.body.classList.add('locked');
    var f = p.querySelector('a,button,input');
    if (f) f.focus({ preventScroll: true });
  }
  function closePanels() {
    $$('.panel').forEach(function (p) { p.classList.remove('on'); p.setAttribute('aria-hidden', 'true'); });
    if (scrim) scrim.classList.remove('on');
    document.body.classList.remove('locked');
    var b = $('#burger');
    if (b) b.setAttribute('aria-expanded', 'false');
  }
  window.utcOpenPanel = openPanel;

  var burger = $('#burger');
  if (burger) burger.addEventListener('click', function () {
    burger.setAttribute('aria-expanded', 'true');
    openPanel('menu');
  });

  var cartBtn = $('#cartbtn');
  if (cartBtn) cartBtn.addEventListener('click', function () { refreshCart(true); });

  if (scrim) scrim.addEventListener('click', closePanels);
  $$('[data-close]').forEach(function (b) { b.addEventListener('click', closePanels); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* Οδηγός μεγεθών από footer/PDP */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('#sglink, .sgopen');
    if (t) { e.preventDefault(); openPanel('sizeguide'); }
  });

  /* ---------- διάφανο header πάνω στο hero ---------- */
  function ghost() {
    var hero = $('.hero');
    if (!hero) { document.body.classList.remove('ghost'); return; }
    document.body.classList.toggle('ghost', window.scrollY < 40);
  }
  window.addEventListener('scroll', ghost, { passive: true });
  ghost();

  /* ---------- hero: ο τίτλος σε μία γραμμή ---------- */
  function fitHero() {
    var h = $('#heroTitle');
    if (!h) return;
    h.style.fontSize = '';
    var parent = h.parentElement;
    if (!parent) return;
    var max = parent.clientWidth;
    var size = parseFloat(getComputedStyle(h).fontSize);
    var guard = 0;
    while (h.scrollWidth > max && size > 18 && guard < 60) {
      size -= 2; h.style.fontSize = size + 'px'; guard++;
    }
  }
  var fitTimer;
  window.addEventListener('resize', function () {
    clearTimeout(fitTimer); fitTimer = setTimeout(fitHero, 120);
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHero);
  setTimeout(fitHero, 300);

  /* ---------- οριζόντιες σειρές ---------- */
  function railState() {
    $$('.rail').forEach(function (r) {
      var nav = r.parentElement ? r.parentElement.querySelector('.railnav') : null;
      if (!nav) return;
      var scrollable = r.scrollWidth - r.clientWidth > 8;
      nav.style.display = scrollable ? '' : 'none';
      var prev = nav.querySelector('[data-dir="-1"]'), next = nav.querySelector('[data-dir="1"]');
      if (prev) prev.disabled = r.scrollLeft < 8;
      if (next) next.disabled = r.scrollLeft + r.clientWidth >= r.scrollWidth - 8;
    });
  }
  $$('.rail').forEach(function (r) { r.addEventListener('scroll', railState, { passive: true }); });
  window.addEventListener('resize', railState);
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.rnav');
    if (!b) return;
    var rail = document.getElementById(b.dataset.rail);
    if (!rail) return;
    var card = rail.querySelector('.card, .moncard');
    var step = card ? card.getBoundingClientRect().width + 22 : 300;
    rail.scrollBy({ left: step * parseInt(b.dataset.dir, 10) * 2, behavior: 'smooth' });
  });
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(railState);
    $$('.rail').forEach(function (r) { ro.observe(r); });
  }
  requestAnimationFrame(railState);

  /* ---------- καρτέλες αρχικής ---------- */
  function showTab(key) {
    $$('.tab').forEach(function (t) {
      var on = t.dataset.tab === key;
      t.classList.toggle('on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    $$('[data-pane]').forEach(function (p) { p.hidden = p.dataset.pane !== key; });
    railState();
  }

  $$('.tab').forEach(function (tab) {
    tab.addEventListener('click', function () { showTab(tab.dataset.tab); });
  });

  /* Η κόκκινη σφραγίδα πάνω στο πρώτο προϊόν στέλνει στις νέες αφίξεις. */
  document.addEventListener('click', function (e) {
    var jump = e.target.closest('[data-goto-tab]');
    if (!jump) return;
    e.preventDefault();
    e.stopPropagation();
    showTab(jump.dataset.gotoTab);
    var tabs = $('.tabs');
    if (tabs) tabs.scrollIntoView({ block: 'center', behavior: 'smooth' });
  });

  /* ---------- γρήγορη προσθήκη από κάρτα ---------- */
  document.addEventListener('click', function (e) {
    var add = e.target.closest('button.qadd');
    if (add) {
      e.preventDefault(); e.stopPropagation();
      var shot = add.closest('.card').querySelector('.shot');
      $$('.shot.picking').forEach(function (x) { if (x !== shot) x.classList.remove('picking'); });
      shot.classList.toggle('picking');
      return;
    }
    var size = e.target.closest('.qsizes button[data-vid]');
    if (size && !size.disabled) {
      e.preventDefault(); e.stopPropagation();
      addToCart(size.dataset.vid, 1, size);
      var s = size.closest('.shot');
      if (s) s.classList.remove('picking');
      return;
    }
    if (!e.target.closest('.qsizes')) {
      $$('.shot.picking').forEach(function (x) { x.classList.remove('picking'); });
    }
  });

  /* ---------- καλάθι ---------- */
  function addToCart(variantId, qty, btn) {
    if (btn) btn.disabled = true;
    fetch(U.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] })
    })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { return refreshCart(true); })
      .then(function () { toast(U.t.added); })
      .catch(function () { toast(U.t.err); })
      .finally(function () { if (btn) btn.disabled = false; });
  }
  window.utcAddToCart = addToCart;

  function changeLine(key, qty) {
    fetch(U.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshCart(false); })
      .catch(function () { toast(U.t.err); });
  }

  function renderCart(cart) {
    var body = $('#cart-body');
    var count = $('#cartcount');
    var n = $('#cart-n');
    var total = $('#cart-total');

    if (count) count.textContent = cart.item_count;
    if (n) n.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (total) total.textContent = money(cart.total_price);

    if (body) {
      if (!cart.items.length) {
        body.innerHTML = '<p class="cart-empty">' + U.t.empty + '</p>';
      } else {
        body.innerHTML = cart.items.map(function (it) {
          return '<div class="citem" data-key="' + it.key + '">' +
            '<img src="' + (it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '') + '" alt="">' +
            '<div class="ci-in">' +
              '<h4>' + it.product_title + '</h4>' +
              '<p class="ci-var">' + (it.variant_title || '') + '</p>' +
              '<div class="ci-bot">' +
                '<div class="qty">' +
                  '<button type="button" data-q="-1" aria-label="-">−</button>' +
                  '<span>' + it.quantity + '</span>' +
                  '<button type="button" data-q="1" aria-label="+">+</button>' +
                '</div>' +
                '<span class="ci-px">' + money(it.final_line_price) + '</span>' +
              '</div>' +
              '<button type="button" class="ci-rm" data-rm>×</button>' +
            '</div></div>';
        }).join('');
      }
    }

    /* μπάρα δωρεάν αποστολής */
    var bar = $('#fsbar'), msg = $('#fsmsg'), fill = $('#fsfill');
    if (bar && U.freeShipping > 0) {
      if (!cart.item_count) { bar.hidden = true; }
      else {
        bar.hidden = false;
        var left = U.freeShipping - cart.total_price;
        var pct = Math.min(100, Math.round(cart.total_price / U.freeShipping * 100));
        if (left > 0) {
          bar.classList.remove('done');
          if (msg) msg.innerHTML = (U.t.fsLeft || '').replace('{x}', '<b>' + money(left) + '</b>');
        } else {
          bar.classList.add('done');
          if (msg) msg.textContent = U.t.fsDone || '';
        }
        if (fill) fill.style.width = pct + '%';
      }
    }
  }

  function refreshCart(open) {
    return fetch(U.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderCart(cart);
        if (open) openPanel('cart');
        return cart;
      });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('#cart-body [data-q]');
    if (q) {
      var item = q.closest('.citem');
      var cur = parseInt(item.querySelector('.qty span').textContent, 10);
      changeLine(item.dataset.key, Math.max(0, cur + parseInt(q.dataset.q, 10)));
      return;
    }
    var rm = e.target.closest('#cart-body [data-rm]');
    if (rm) {
      var it2 = rm.closest('.citem');
      changeLine(it2.dataset.key, 0);
    }
  });

  /* ---------- σελίδα προϊόντος ---------- */
  (function pdp() {
    var form = $('#pdp-form');
    if (!form) return;

    var dataEl = $('#pdp-variants');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { }

    var chosen = [];
    $$('.sizes[data-opt]').forEach(function (row, i) {
      var on = row.querySelector('button.on');
      chosen[i] = on ? on.dataset.value : null;
    });

    function match() {
      return variants.filter(function (v) {
        return chosen.every(function (val, i) {
          return val === null || v.options[i] === val;
        });
      })[0];
    }

    var atcEl = $('#pdp-atc');
    var atcLabel = atcEl ? atcEl.textContent.trim() : '';

    function sync() {
      var v = match();
      var vid = $('#pdp-vid'), px = $('#pdp-price'), atc = $('#pdp-atc');
      if (!v) {
        if (atc) { atc.disabled = true; atc.textContent = U.t.soldout; }
        return;
      }
      if (vid) vid.value = v.id;
      if (px) px.textContent = money(v.price);
      if (atc) {
        atc.disabled = !v.available;
        atc.textContent = v.available ? atcLabel : U.t.soldout;
      }
      /* Το URL κρατάει το επιλεγμένο variant ώστε να μη χάνεται σε refresh/share. */
      if (window.history && window.history.replaceState) {
        try {
          var u = new URL(window.location.href);
          u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u);
        } catch (err) { }
      }
    }

    $$('.sizes[data-opt] button').forEach(function (b) {
      b.addEventListener('click', function () {
        if (b.disabled) return;
        var idx = parseInt(b.dataset.optIndex, 10) - 1;
        var row = b.closest('.sizes');
        Array.prototype.forEach.call(row.children, function (c) {
          c.classList.remove('on');
          c.setAttribute('aria-pressed', 'false');
        });
        b.classList.add('on');
        b.setAttribute('aria-pressed', 'true');
        chosen[idx] = b.dataset.value;
        sync();
      });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var vid = $('#pdp-vid');
      if (vid && vid.value) addToCart(vid.value, 1, $('#pdp-atc'));
    });

    /* γκαλερί */
    $$('#pdp-thumbs .thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        $$('#pdp-thumbs .thumb').forEach(function (x) { x.classList.remove('on'); });
        t.classList.add('on');
        var stage = $('#pdp-stage');
        if (stage) stage.src = t.dataset.src;
      });
    });
  })();

  /* ---------- newsletter: εμφάνιση φωτογραφίας ---------- */
  (function () {
    var els = $$('.utc-signup .photo');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.25 });
    els.forEach(function (e) { io.observe(e); });
  })();

  /* ---------- βρες το μέγεθός σου ----------
     Δουλεύει με τις ΠΡΑΓΜΑΤΙΚΕΣ μετρήσεις του ρούχου (μισό στήθος ×2)
     και όχι με γενικούς πίνακες, γι' αυτό ισχύει και για ρούχα με άλλη
     κοπή — αρκεί να έχουν δικό τους πίνακα.

     ΔΥΟ ΞΕΧΩΡΙΣΤΟΙ ΑΞΟΝΕΣ, ώστε η πρόταση να είναι πάντα συνεπής:
       • στήθος → ποιο πλάτος χρειάζεται
         περίμετρος ≈ 0,55·βάρος + 0,12·ύψος + 35,5
       • ύψος → ποιο ελάχιστο μήκος χρειάζεται  (0,40·ύψος − 3)
     Το τελικό μέγεθος είναι το μεγαλύτερο των δύο απαιτήσεων.

     Ελέγχθηκε σε όλο το εύρος 150–210 cm / 45–140 kg και στις τρεις
     εφαρμογές: περισσότερα κιλά ή περισσότερο ύψος ΠΟΤΕ δεν βγάζουν
     μικρότερο μέγεθος (0 παραβιάσεις μονοτονίας σε 22.000 συνδυασμούς).

     Η άνεση ανά εφαρμογή ρυθμίζεται: Ρυθμίσεις θέματος → Μεγέθη.        */
  (function () {
    var box = document.getElementById('size-finder');
    if (!box) return;
    var raw = document.getElementById('sf-data');
    if (!raw) return;

    var data;
    try { data = JSON.parse(raw.textContent); } catch (e) { return; }
    if (!data.rows || !data.rows.length) return;

    var hEl = document.getElementById('sf-h');
    var wEl = document.getElementById('sf-w');
    var hOut = document.getElementById('sf-hv');
    var wOut = document.getElementById('sf-wv');
    var sizeOut = document.getElementById('sf-size');
    var hint = document.getElementById('sf-hint');
    var pick = document.getElementById('sf-pick');
    var fit = 'regular';
    var current = null;

    function bodyChest(h, w) {
      return 0.55 * w + 0.12 * h + 35.5;
    }

    function recommend(h, w, f) {
      var ease = data.ease[f];
      if (typeof ease !== 'number') ease = 8;
      var target = bodyChest(h, w) + ease;

      var best = 0, bestD = Infinity;
      data.rows.forEach(function (r, i) {
        var d = Math.abs(r.width * 2 - target);
        if (d < bestD) { bestD = d; best = i; }
      });

      /* Ψηλός και λεπτός: το στήθος δείχνει μικρό μέγεθος, αλλά το ρούχο
         θα του κοντεύει. Ανεβάζουμε όσο χρειάζεται να φτάσει το μήκος. */
      var minLen = 0.40 * h - 3;
      while (best < data.rows.length - 1 && data.rows[best].length < minLen) best++;

      return data.rows[best];
    }

    function paintTable(size) {
      $$('#size-finder .sfind-table [data-size]').forEach(function (c) {
        c.classList.toggle('on', c.getAttribute('data-size') === size);
      });
    }

    function update() {
      var h = parseInt(hEl.value, 10), w = parseInt(wEl.value, 10);
      hOut.textContent = h + ' cm';
      wOut.textContent = w + ' kg';
      current = recommend(h, w, fit);
      sizeOut.textContent = current.size;
      paintTable(current.size);
      if (pick) {
        pick.hidden = !findSizeBtn(current.size);
        pick.textContent = window.UTC.t.sf_pick;
      }
    }

    function findSizeBtn(size) {
      var hit = null;
      $$('.sizes button').forEach(function (b) {
        if (!hit && (b.dataset.value || '').trim().toLowerCase() === String(size).trim().toLowerCase()) hit = b;
      });
      return hit;
    }

    $$('#size-finder .sfind-fit').forEach(function (b) {
      b.addEventListener('click', function () {
        fit = b.dataset.fit;
        $$('#size-finder .sfind-fit').forEach(function (x) { x.classList.toggle('on', x === b); });
        hint.textContent = b.getAttribute('title') || '';
        update();
      });
    });

    hEl.addEventListener('input', update);
    wEl.addEventListener('input', update);

    if (pick) {
      pick.addEventListener('click', function () {
        if (!current) return;
        var btn = findSizeBtn(current.size);
        if (!btn) return;
        btn.click();
        pick.textContent = window.UTC.t.sf_picked;
        box.open = false;
        btn.scrollIntoView({ block: 'center', behavior: 'smooth' });
      });
    }

    update();
  })();

  /* ---------- αρχικό γέμισμα καλαθιού ---------- */
  refreshCart(false);
})();

/* Under The Cross — φωτογραφία ανά χρώμα */
(function () {
  var gal = document.querySelector('.gal');
  if (!gal) return;
  var thumbs = [].slice.call(gal.querySelectorAll('.thumbs .thumb'));
  if (thumbs.length < 2) return;
  var byId = null;
  function fileOf(u) { return u ? u.split('?')[0].split('/').pop() : ''; }
  function currentVariantId() {
    var q = new URLSearchParams(location.search).get('variant');
    if (q) return q;
    var f = document.querySelector('form[action*="/cart/add"] [name="id"]');
    return f ? f.value : null;
  }
  function sync() {
    if (!byId) return;
    var v = byId[currentVariantId()];
    if (!v || !v.featured_image) return;
    var want = fileOf(v.featured_image.src);
    for (var i = 0; i < thumbs.length; i++) {
      var img = thumbs[i].querySelector('img');
      if (img && fileOf(img.getAttribute('src')) === want) {
        if (!thumbs[i].classList.contains('on')) thumbs[i].click();
        return;
      }
    }
  }
  fetch(location.pathname.split('?')[0] + '.js')
    .then(function (r) { return r.json(); })
    .then(function (p) { byId = {}; p.variants.forEach(function (v) { byId[v.id] = v; }); sync(); })
    .catch(function () {});
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.sizes button[data-opt-index]')) setTimeout(sync, 80);
  });
})();

/* Under The Cross — γκρίζα τα εξαντλημένα μεγέθη ανά χρώμα */
(function () {
  var json = document.getElementById('pdp-variants');
  if (!json) return;
  var variants;
  try { variants = JSON.parse(json.textContent); } catch (e) { return; }
  var groups = [].slice.call(document.querySelectorAll('.sizes[data-opt]'));
  if (!variants || groups.length < 2) return;
  var busy = false;
  function selectedValues() {
    return groups.map(function (g) { var on = g.querySelector('button.on'); return on ? on.getAttribute('data-value') : null; });
  }
  function refresh() {
    if (busy) return;
    busy = true;
    var sel = selectedValues();
    groups.forEach(function (g, gi) {
      [].slice.call(g.querySelectorAll('button')).forEach(function (b) {
        var val = b.getAttribute('data-value');
        var ok = variants.some(function (v) {
          if (!v.available) return false;
          for (var i = 0; i < groups.length; i++) {
            var want = (i === gi) ? val : sel[i];
            if (want != null && v['option' + (i + 1)] !== want) return false;
          }
          return true;
        });
        b.classList.toggle('out', !ok);
        b.disabled = !ok;
      });
    });
    busy = false;
    for (var i = 0; i < groups.length; i++) {
      var on = groups[i].querySelector('button.on');
      if (on && on.classList.contains('out')) {
        var alt = groups[i].querySelector('button:not(.out)');
        if (alt) { alt.click(); return; }
      }
    }
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.sizes button[data-opt-index]')) setTimeout(refresh, 60);
  });
  refresh();
})();